import { RefObject, useEffect } from 'react';
import { useSessionStorage } from '@app/react/hooks/useSessionStorage';
import { debounce } from 'lodash';

// sets scrollY position of window based on a setting condition, i.e. when api calls are done
// also sets the scroll position when unmounting, i.e. a user navigates to a different page
export const useWindowScrollPosition = (
    storageKey: string,
    setCondition: boolean,
    target: RefObject<Element>,
): void => {
    const [scrollStorage, setScrollStorage] = useSessionStorage(storageKey, { x: 0, y: 0 }, false);

    useEffect(() => {
        if (setCondition) {
            target.current?.scrollTo(scrollStorage.x, scrollStorage.y);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setCondition, scrollStorage]);

    useEffect(() => {
        const save = () => {
            const {
                scrollLeft: x = 0,
                scrollTop: y = 0,
            } = target.current;
            setScrollStorage({ x, y });
        };

        const handleSave = debounce(() => {
            save();
        }, 500);

        const t = target.current;
        t?.addEventListener('scroll', handleSave);

        return () => {
            t?.removeEventListener('scroll', handleSave);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
